<template>
  <section class="mine-course">
    <div class="mine-item-wrapper" v-for="item in courseList" :key="item.id">
      <mine-item :course="item" @showNotice="showNotice" />
    </div>
    <div class="mine-no-course" v-if="!courseList.length">
      <p>你还没有购买任何课程 : (</p>
      <router-link :to="{ name: 'recommend' }">
        <button class="mine-noCourse-toBuy">去选课</button>
      </router-link>
    </div>
    <notice ref="notice" :closeBtn="true">
      <div class="mine-coursewave">
        <p>复制链接：</p>
        <p>{{downLoadUrl}}</p>
        <p>在电脑端浏览器打开即可进行下载哦~</p>
      </div>
    </notice>
  </section>

</template>

<script>
/** eslint-disable */
import MineItem from "../components/Mine/Item.vue";
import Notice from '../components/Notice.vue'

export default {
  name: "MineCourse",
  data() {
    return {
      downLoadUrl: ''
    }
  },
  props: {
    courseList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  components: {
    MineItem,
    Notice
  },
  methods: {
    showNotice(url) {
      this.downLoadUrl = url
      this.$refs.notice.show()
    } 
  },
};
</script>

<style lang="scss">
@import "../style/main";
.mine-course {
	overflow-y: scroll;
	height: 100%;
  background-color: #f3f4f6;
}

.mine-item-wrapper {
	margin: rem(20) auto 0;
	width: rem(690);
}

.mine-no-course {
	text-align: center;
	padding: rem(102) 0;
	color: #999;
	font-size: rem(28);
	button {
		margin-top: rem(62);
		width: rem(250);
		height: rem(78);
		outline: none;
		border: none;
		border-radius: 3px;
		background-image: linear-gradient(-135deg, #f48f00 0%, #ffb500 100%);
		font-family: PingFangSC-Medium;
		font-size: rem(34);
		color: #fff;
	}
}
.mine-coursewave {
  padding: use(50) use(50) use(90);
  p{
    font-size: use(27);
    color: #666666;
    text-align: center;
    line-height: use(60);
  }
  p:nth-child(2){
    color: #39A1FF;
    font-size: use(30);
    word-break: break-word;
  }
}
</style>